import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/api/account.service';
import { LoadingController, ToastController, NavController, MenuController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

const PasswordValidator: ValidatorFn = (fg: FormGroup) => {
  const password1 = fg.get('newPassword1').value;
  const password2 = fg.get('newPassword2').value;
  return !!password1 && !!password2 && password1 !== password2
    ?  { 'passwordDifference': true }
    : null;
};

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {

  public resetForm: FormGroup; 

  public newPassword1Type: string = 'password';
  public newPassword1Icon: string = 'eye-off';
  public newPassword2Type: string = 'password';
  public newPassword2Icon: string = 'eye-off';

  private uid:string;
  private token:string;

  constructor(
    private accountService: AccountService,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private menuCtrl: MenuController,
  ) { }

  ngOnInit() {
    this.menuCtrl.enable(false);
    this.resetForm = this.formBuilder.group({
      'newPassword1': [null, Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(128),
      ])],
      'newPassword2': [null, Validators.compose([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(128)
      ])],
    }, {validator: PasswordValidator})
  }

  ionViewWillEnter() {
    this.uid = this.activatedRoute.snapshot.params['uid'];
    this.token = this.activatedRoute.snapshot.params['token'];
  }

  async resetPassword() {
    let password1 = this.resetForm.get('newPassword1').value;
    let password2 = this.resetForm.get('newPassword2').value;

    let loader = await this.loadingCtrl.create({
      message: "Reseting your password"
    })
    loader.present();

    this.accountService.resetPassword(this.uid, this.token, password1,password2)
    .then(async () => {
      loader.dismiss();
      let toast = await this.toastCtrl.create({
        message: 'Password successfuly reset',
        color: 'light',
        duration: 2000,
        showCloseButton: true,
      })
      toast.present();
      this.backToHome();
    })
    .catch(async (error) => {
      let errorMessage = "";

      if (error.status === 404) {
        errorMessage = "This reset link is incorrect."
      } else {
        Object.keys(error.error).forEach(key => {
          if (key === "token" || key === "uid") {
            errorMessage = "This reset link is incorrect or no longer available."
            return true;
          }
          errorMessage += key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ") + " : ";
          error.error[key].forEach(err => {
            errorMessage += err
          });
          return false;
        });
      }

      loader.dismiss();

      let toast = await this.toastCtrl.create({
        message: errorMessage,
        duration: 3000,
        showCloseButton: true,
        position: 'bottom',
        color: 'light',
      })

      toast.present();

    });
  }

  hideShowNewPassword1() {
    this.newPassword1Type = this.newPassword1Type === 'text' ? 'password' : 'text';
    this.newPassword1Icon = this.newPassword1Icon === 'eye-off' ? 'eye' : 'eye-off';
  }

  hideShowNewPassword2() {
    this.newPassword2Type = this.newPassword2Type === 'text' ? 'password' : 'text';
    this.newPassword2Icon = this.newPassword2Icon === 'eye-off' ? 'eye' : 'eye-off';
  }

  backToHome() {
    this.navCtrl.navigateBack('/');
  }
}
